import { useQuery } from '@tanstack/react-query';

import { stripeService } from '@/services/stripe';
import { StripeV2PricesRequest } from '@/services/stripe/dto';

const TWO_MINUTES_IN_MS = 60 * 2 * 1000;

export const useQueryStripeV2Prices = (params: StripeV2PricesRequest) => {
  const {
    data: pricesData,
    isLoading,
    isSuccess,
    error,
  } = useQuery({
    queryFn: () => stripeService.getV2Prices(params),
    queryKey: ['stripeV2Prices', params],
    cacheTime: TWO_MINUTES_IN_MS,
    enabled: params.subscriptions.length > 0 || params.coins.length > 0,
  });

  return {
    pricesData,
    isLoading,
    isSuccess,
    error,
    subscriptions: pricesData?.subscriptions || [],
    coins: pricesData?.coins || [],
    billingPortalLink: pricesData?.billing_portal_link,
  };
};
